<template>
    <v-modal-confirmed accept-button-text="Borrar"
                       close-button-text="Cancelar"
                       title="Borrar tarea"
                       confirm-modal-accept-button-text="Sí"
                       confirm-modal-close-button-text="No"
                       confirm-modal-text="¿Estás seguro?"
                       confirm-modal-title="Confirmar..."
                       @closed="closeModal"
                       @accepted="deleteTask">
        <span>¿Seguro que quieres eliminar esta tarea?</span>
        <div>Nombre: <span class="fw-bold">{{ task.name }}</span></div>
        <div>Descripción: <span class="fw-bold">{{ task.description }}</span></div>
        <div>Tipo: <span class="fw-bold">{{ task.type }}</span></div>
        <div>Estado: <span class="fw-bold">{{ task.status }}</span></div>
    </v-modal-confirmed>
</template>

<script>
import VModalConfirmed from "../../general/VModalConfirmed";
import {deleteTask} from "../../../helpers/requests/RequestsTasks";

export default {
    name: "TaskDeleteModal",
    components: {
        VModalConfirmed
    },
    props: {
        task: {
            type: Object,
            required: true,
        },
    },
    methods: {
        async deleteTask() {
            try {
                await deleteTask(this.task);

                this.$store.dispatch('app/setToastMessage', 'Tarea eliminada');

                this.$emit('task-deleted');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al eliminar la tarea');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
